import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "core-js/modules/es6.regexp.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var InsuranceClaim =
/*#__PURE__*/
function (_BaseData) {
  _inherits(InsuranceClaim, _BaseData);

  function InsuranceClaim() {
    _classCallCheck(this, InsuranceClaim);

    return _possibleConstructorReturn(this, _getPrototypeOf(InsuranceClaim).call(this, "InsuranceClaim"));
  }

  _createClass(InsuranceClaim, [{
    key: "CheckForDuplicates",
    value: function () {
      var _CheckForDuplicates = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(invoiceNumber, invoiceDate, vendorName, index) {
        var dateArray, date;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dateArray = invoiceDate.split("/");
                date = dateArray[1] + "-" + dateArray[2] + "-" + dateArray[0];
                return _context.abrupt("return", axios.get("/api/CheckForInsuranceDuplicates/".concat(invoiceNumber, "/").concat(date, "/").concat(vendorName, "/").concat(index)));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function CheckForDuplicates(_x, _x2, _x3, _x4) {
        return _CheckForDuplicates.apply(this, arguments);
      }

      return CheckForDuplicates;
    }()
  }, {
    key: "DeleteCheck",
    value: function () {
      var _DeleteCheck = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(InsuranceClaimCheck_Id) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.post("/api/".concat(this._controller, "/deleteInsuranceClaimCheck/").concat(InsuranceClaimCheck_Id)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function DeleteCheck(_x5) {
        return _DeleteCheck.apply(this, arguments);
      }

      return DeleteCheck;
    }()
  }, {
    key: "DenyRequest",
    value: function () {
      var _DenyRequest = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(InsuranceClaimRequest_Id) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.post("/api/denyInsuranceClaimRequest/".concat(InsuranceClaimRequest_Id)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function DenyRequest(_x6) {
        return _DenyRequest.apply(this, arguments);
      }

      return DenyRequest;
    }()
  }, {
    key: "Download",
    value: function () {
      var _Download = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(fileId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.get("/api/InsuranceClaimDownload/".concat(fileId)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function Download(_x7) {
        return _Download.apply(this, arguments);
      }

      return Download;
    }()
  }, {
    key: "ApproveDenyClaim",
    value: function () {
      var _ApproveDenyClaim = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(claimId, statusId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.get("/api/".concat(this._controller, "/ApproveDenyClaim/").concat(claimId, "/").concat(statusId)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function ApproveDenyClaim(_x8, _x9) {
        return _ApproveDenyClaim.apply(this, arguments);
      }

      return ApproveDenyClaim;
    }()
  }, {
    key: "GetClaim",
    value: function () {
      var _GetClaim = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(claimId, projectId, isAdmin) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", axios.get("/api/".concat(this._controller, "/GetInsuranceClaim/").concat(claimId, "/").concat(projectId, "/").concat(isAdmin)));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function GetClaim(_x10, _x11, _x12) {
        return _GetClaim.apply(this, arguments);
      }

      return GetClaim;
    }()
  }, {
    key: "GetInsurance_List",
    value: function () {
      var _GetInsurance_List = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(isAdmin, userId, projectId) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", axios.get("/api/".concat(this._controller, "/GetInsuranceClaimList/").concat(isAdmin, "/").concat(userId, "/").concat(projectId)));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function GetInsurance_List(_x13, _x14, _x15) {
        return _GetInsurance_List.apply(this, arguments);
      }

      return GetInsurance_List;
    }()
  }, {
    key: "GetProperty_List",
    value: function () {
      var _GetProperty_List = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(isAdmin, userId) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", axios.get("/api/".concat(this._controller, "/GetInsuranceClaimPropertyList/").concat(isAdmin, "/").concat(userId)));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function GetProperty_List(_x16, _x17) {
        return _GetProperty_List.apply(this, arguments);
      }

      return GetProperty_List;
    }()
  }, {
    key: "AdminChangeStatus",
    value: function () {
      var _AdminChangeStatus = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(HeaderId, StatusId) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", axios.get("api/".concat(this._controller, "/InsuranceClaimAdminChangeStatus/").concat(HeaderId, "/").concat(StatusId)));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function AdminChangeStatus(_x18, _x19) {
        return _AdminChangeStatus.apply(this, arguments);
      }

      return AdminChangeStatus;
    }()
  }, {
    key: "GetYearOptions",
    value: function () {
      var _GetYearOptions = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", axios.get("api/".concat(this._controller, "/GetYearOptions")));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function GetYearOptions() {
        return _GetYearOptions.apply(this, arguments);
      }

      return GetYearOptions;
    }()
  }, {
    key: "SaveClaim",
    value: function () {
      var _SaveClaim = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(date, insuranceProvider, typeOfLoss_Id, otherTypeOfLoss, description, amountClaimed, receivedStatementOfLoss, status, requestId, projectId, itemDeleteIndexes, requestDeleteIndexes, itemTableData, requestTableData, comments, userId, dateSubmitted) {
        var items, requests, InsuranceClaim;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                items = [];
                itemTableData.forEach(function (x) {
                  return items.push({
                    Items: x.items,
                    UnitsAffected: x.unitsAffected,
                    InsuranceClaimItem_Id: x.insuranceClaimItem_Id
                  });
                });
                requests = [];
                requestTableData.forEach(function (x) {
                  return requests.push({
                    InsuranceClaimRequest_Id: x.insuranceClaimRequest_Id
                  });
                });
                InsuranceClaim = {
                  DateOfLoss: date,
                  Description: description,
                  InsuranceProvider: insuranceProvider,
                  InsuranceClaimTypeOfLoss_Id: typeOfLoss_Id,
                  OtherTypeOfLoss: otherTypeOfLoss,
                  TotalAmountClaimed: amountClaimed,
                  ReceivedStatementOfLoss: receivedStatementOfLoss,
                  InsuranceClaimItem: items,
                  InsuranceClaimRequest: requests,
                  Status_Id: status,
                  InsuranceClaim_Id: requestId,
                  Project_Id: projectId,
                  MHDCComments: comments,
                  SubmittedBy: userId,
                  DateSubmitted: dateSubmitted
                };
                return _context11.abrupt("return", axios.post("/api/".concat(this._controller, "/saveInsuranceClaimProgress"), {
                  InsuranceClaim: InsuranceClaim,
                  itemDeleteIndexes: itemDeleteIndexes,
                  requestDeleteIndexes: requestDeleteIndexes
                }));

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function SaveClaim(_x20, _x21, _x22, _x23, _x24, _x25, _x26, _x27, _x28, _x29, _x30, _x31, _x32, _x33, _x34, _x35, _x36) {
        return _SaveClaim.apply(this, arguments);
      }

      return SaveClaim;
    }()
  }, {
    key: "SendInsuranceClaimEmail",
    value: function () {
      var _SendInsuranceClaimEmail = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12(InsuranceClaimId) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", axios.post("/api/".concat(this._controller, "/SendInsuranceClaimEmail/").concat(InsuranceClaimId)));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function SendInsuranceClaimEmail(_x37) {
        return _SendInsuranceClaimEmail.apply(this, arguments);
      }

      return SendInsuranceClaimEmail;
    }()
  }, {
    key: "CheckForDuplicateRequestItems",
    value: function () {
      var _CheckForDuplicateRequestItems = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13(InsuranceClaimId, itemToCheck) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", axios.post("/api/".concat(this._controller, "/CheckForDuplicateRequestItems/").concat(InsuranceClaimId), itemToCheck));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function CheckForDuplicateRequestItems(_x38, _x39) {
        return _CheckForDuplicateRequestItems.apply(this, arguments);
      }

      return CheckForDuplicateRequestItems;
    }()
  }, {
    key: "SaveCheck",
    value: function () {
      var _SaveCheck = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14(row, claimId) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", axios.post("/api/".concat(this._controller, "/saveInsuranceClaimCheck"), {
                  InsuranceClaimCheck_Id: row.insuranceClaimCheck_Id,
                  CheckNumber: row.checkNumber,
                  CheckToMHDC: row.checkToMHDC,
                  CheckProvider: row.checkProvider,
                  CheckAmountRecieved: parseFloat(row.checkAmountRecieved),
                  KansasCityNotificationDate: row.kansasCityNotificationDate,
                  InsuranceClaim_Id: claimId
                }));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function SaveCheck(_x40, _x41) {
        return _SaveCheck.apply(this, arguments);
      }

      return SaveCheck;
    }()
  }, {
    key: "SaveRequest",
    value: function () {
      var _SaveRequest = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15(row, claimId, documentDeleteIndexes) {
        var request;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                request = {
                  InsuranceClaimRequest_Id: row.insuranceClaimRequest_Id,
                  CheckNumber: row.checkNumber,
                  ClaimAmount: row.claimAmount,
                  DuplicateInvoiceComment: row.comments,
                  Description: row.description,
                  InvoiceDate: row.invoiceDate,
                  invoiceNumber: row.invoiceNumber,
                  Narrative: row.narrative,
                  PayVendorDirect: row.payDirectly == "yes" ? true : false,
                  UnitsAffected: row.unitsAffected,
                  InsuranceClaim_Id: claimId,
                  Vendor: {
                    VendorId: row.vendor.value,
                    Name: row.vendor.label,
                    Address: row.vendorAddress,
                    City: row.vendorCity,
                    State: row.vendorState,
                    Zip: row.vendorZip
                  }
                };
                return _context15.abrupt("return", axios.post("/api/saveInsuranceClaimRequest", {
                  request: request,
                  documentDeleteIndexes: documentDeleteIndexes
                }));

              case 2:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      function SaveRequest(_x42, _x43, _x44) {
        return _SaveRequest.apply(this, arguments);
      }

      return SaveRequest;
    }()
  }, {
    key: "SaveReview",
    value: function () {
      var _SaveReview = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16(row, status) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                debugger;
                return _context16.abrupt("return", axios.post("/api/saveInsuranceClaimReview", {
                  InsuranceClaimRequest_Id: row.insuranceClaimRequest_Id,
                  CheckNumber: row.checkNumber,
                  ClaimAmount: row.claimAmount,
                  DuplicateInvoiceComment: row.comments,
                  Description: row.description,
                  InvoiceDate: row.invoiceDate,
                  invoiceNumber: row.invoiceNumber,
                  Narrative: row.narrative,
                  PayVendorDirect: row.payDirectly == "yes" ? true : false,
                  UnitsAffected: row.unitsAffected,
                  InsuranceClaim_Id: row.InsuranceClaim_Id,
                  Vendor_Id: row.vendorId,
                  ApprovedAmount: row.approvedAmount,
                  DateReportedToCO: row.dateReportedToCO,
                  DateMemoRelease: row.dateMemoRelease,
                  ClaimChecksSent: row.claimChecksSent,
                  InspectorVisit: row.inspectorVisit,
                  PicturesRecieved: row.picturesRecieved,
                  Status_Id: status,
                  MHDCComments: row.mhdcComments,
                  SubmittedById: row.submittedById
                }));

              case 2:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      function SaveReview(_x45, _x46) {
        return _SaveReview.apply(this, arguments);
      }

      return SaveReview;
    }()
  }]);

  return InsuranceClaim;
}(BaseData);

export default new InsuranceClaim();